/* eslint-disable */
export default {
  _star: 'star',
}